var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        { attrs: { titulo: _vm.title }, on: { cerrar: _vm.handleCerrar } },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn-continuar",
              on: { click: _vm.handleSaveClient }
            },
            [_vm._v("\n      Guardar\n    ")]
          )
        ],
        1
      ),
      _c(
        "v-card",
        { attrs: { height: "55px", flat: "" } },
        [
          _c(
            "v-bottom-nav",
            {
              attrs: {
                value: true,
                active: _vm.pasos.informacionGeneral.step,
                absolute: "",
                color: "transparent"
              },
              on: {
                "update:active": function($event) {
                  return _vm.$set(_vm.pasos.informacionGeneral, "step", $event)
                }
              }
            },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.informacionGeneral.visible,
                      expression: "pasos.informacionGeneral.visible"
                    }
                  ],
                  attrs: {
                    color: "primary",
                    flat: "",
                    value: _vm.pasos.informacionGeneral.step
                  }
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.title))]),
                  _c("v-icon", { attrs: { dark: "", icon: "", bottom: "" } }, [
                    _vm._v("dashboard")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "cardnew", attrs: { align: "center" } }, [
        _c("br"),
        _c(
          "div",
          { attrs: { id: "formDivCreate" } },
          [
            _c(
              "v-flex",
              { attrs: { md10: "" } },
              [
                _c(
                  "v-card",
                  { staticClass: "rounded-card" },
                  [
                    _c(
                      "v-form",
                      {
                        ref: "form",
                        staticClass: "col-md-12",
                        attrs: { "lazy-validation": "" },
                        model: {
                          value: _vm.isFormValid,
                          callback: function($$v) {
                            _vm.isFormValid = $$v
                          },
                          expression: "isFormValid"
                        }
                      },
                      [
                        _c(
                          "v-container",
                          { attrs: { "grid-list-md": "" } },
                          [
                            _c(
                              "FormFieldsContainer",
                              { attrs: { titulo: _vm.title } },
                              [
                                _vm._t("prependInformacionGeneral"),
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "", sm6: "", md6: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.formFields.nombre.label,
                                        "data-vv-name": "name",
                                        "error-messages": _vm.errors.collect(
                                          "name"
                                        ),
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.formFields.nombre.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.nombre,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.nombre.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "", sm6: "", md6: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        "error-messages": _vm.errors.collect(
                                          "leaderItem"
                                        ),
                                        "data-vv-name": "leaderItem",
                                        "prepend-icon": "person",
                                        label: "Líder",
                                        items: _vm.leaders,
                                        color: "primary",
                                        clearable: true,
                                        "item-text": "nombre",
                                        "item-value": "id",
                                        "no-data-text": "Sin resultados",
                                        required: ""
                                      },
                                      on: {
                                        change: _vm.handleChangeAutocomplete
                                      },
                                      model: {
                                        value: _vm.leaderItem,
                                        callback: function($$v) {
                                          _vm.leaderItem = $$v
                                        },
                                        expression: "leaderItem"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-flex",
              { staticStyle: { "margin-top": "30px" }, attrs: { md10: "" } },
              [
                _c(
                  "v-card",
                  { staticClass: "rounded-card" },
                  [
                    _c("v-container", { attrs: { "grid-list-md": "" } }, [
                      _c(
                        "div",
                        { staticClass: "v-title", attrs: { align: "left" } },
                        [
                          _c("h2", [
                            _vm._v(
                              "\n                Asociar Ejecutivos\n              "
                            )
                          ]),
                          _c("v-divider"),
                          _c("br"),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                sm12: "",
                                md12: "",
                                layout: "",
                                wrap: ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { sm3: "", md3: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "append-icon": "search",
                                      label: "Buscar...",
                                      "single-line": "",
                                      "hide-details": ""
                                    },
                                    on: { input: _vm.handleExecutiveSearch },
                                    model: {
                                      value: _vm.executiveSearch,
                                      callback: function($$v) {
                                        _vm.executiveSearch = $$v
                                      },
                                      expression: "executiveSearch"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("br"),
                          _c("MantenedorGridSinCodigo", {
                            attrs: {
                              "grid-options": _vm.gridOptions,
                              mostrarAcciones: false,
                              verCheckbox: false,
                              "funcionalidad-id": _vm.funcionalidad
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }